module.exports = __webpack_public_path__ + "static/pinkbearcomf-f289db72ab308cbdd6d9818fe4fe04ad.jpeg";